export const openLink = (link) => {
  window.location.href = link;
};
